import { icons } from '@images';

export function MobileFallback(): React.JSX.Element {
  return (
    <div className="bg-screen flex min-h-screen flex-col items-center justify-center px-8 text-center">
      <img src={icons.MyraAiBetaIcon} alt="myra.AI beta" className="mb-4 h-[48px]" />
      <p className="font-ivypresto text-primary mb-3 text-[28px] leading-[36px] font-normal tracking-wide">
        Your AI Assistant for Flights & Stays
      </p>
      <p className="font-avenir text-[16px] leading-[22px] font-medium text-[#9b9b9b]">
        Currently available on desktop only
      </p>
    </div>
  );
}
